
import { mapGetters } from 'vuex'
import ProductCard from '~/components/product-card/ProductCard'
import CardProductCollections from '~/components/searchspring/plp-content/cardProductCollections'

export default {
  components: { ProductCard, CardProductCollections },
  computed: {
    ...mapGetters({
      vxSearchResults: 'search/getSearchResults',
      vxStoryContent: 'search/getStoryContent',
      vxIsSearching: 'search/getIsSearching',
    }),
  },
}
